import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ProfileStore } from 'app/state-management/profile/profile.store';

export const hasAnyLicenseGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const profileStore = inject(ProfileStore);
  const router: Router = inject(Router);

  return profileStore.hasAnyLicenseOrNull$.pipe(
    take(1),
    map((hasAnyLicense: boolean) => {
      if (hasAnyLicense === null) {
        return true;
      }
      return hasAnyLicense || router.createUrlTree(['/licenses'])
    })
  );
};
